
// Lineas
export const LINEAS_CAPITAL_TRABAJO = [
    2, // Capital de Trabajo
    4, // Capital de Trabajo Ganaderia
    8, // Capital de Trabajo Para Contingencias Climaticas
];

// Categorias Empresa

export const CAT_PEQ_TRAMO_1 = 3;
export const CAT_PEQ_TRAMO_2 = 4;
export const CAT_MEDIANA_TRAMO_1 = 5;
export const CAT_MEDIANA_TRAMO_2 = 6;

export const ID_CATEGORIA_MAXIMA = CAT_MEDIANA_TRAMO_2;
